import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=4b8a9668&scoped=true&lang=html"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"
import style0 from "./SettingsForm.vue?vue&type=style&index=0&id=4b8a9668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a9668",
  null
  
)

export default component.exports